export default [
  {
    key: 'startDate',
    label: 'field.fromDate',
    type: 'date-time',
    lg: 12,
  },
  {
    key: 'endDate',
    label: 'field.toDate',
    type: 'date-time',
    lg: 12,
  },
];
